import { apiClient } from '../api-client'
import { LoginRequest, LoginResponse, User, UserPermissionsResponse } from '@/types'

// Auth API
export const authApi = {
  login: (data: LoginRequest): Promise<LoginResponse> =>
    apiClient.post('/auth/login', data),

  logout: (): Promise<void> =>
    apiClient.post('/auth/logout'),

  refreshToken: (): Promise<LoginResponse> =>
    apiClient.post('/auth/refresh'),

  getCurrentUser: (): Promise<User> =>
    apiClient.get('/users/me'),

  getUserPermissions: (): Promise<UserPermissionsResponse> =>
    apiClient.get('/users/permissions'),

  listUsers: (filters?: any): Promise<any> =>
    apiClient.get('/users', { params: filters }),

  bulkUpdateUsers: (data: { userIds: string[]; action: string; payload?: any }): Promise<any> =>
    apiClient.post('/auth/users/bulk-update', data),

  exportUsers: (params?: string): Promise<any> =>
    apiClient.get(`/auth/users/export${params ? `?${params}` : ''}`),

  impersonateUser: (userId: string): Promise<any> =>
    apiClient.post('/auth/impersonate', { userId }),

  getUserLoginHistory: (userId: string, params?: string): Promise<any> =>
    apiClient.get(`/auth/users/${userId}/login-history${params ? `?${params}` : ''}`),

  uploadAvatar: (userId: string, file: File): Promise<any> =>
    apiClient.post(`/auth/users/${userId}/avatar`, { file }, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  changePassword: (data: { currentPassword?: string; newPassword: string; userId?: string }): Promise<any> =>
    apiClient.post('/auth/change-password', data),

  setup2FA: (): Promise<any> =>
    apiClient.post('/auth/2fa/setup'),

  verify2FA: (code: string): Promise<any> =>
    apiClient.post('/auth/2fa/verify', { code }),

  disable2FA: (): Promise<any> =>
    apiClient.post('/auth/2fa/disable'),

  getUserSessions: (userId: string): Promise<any> =>
    apiClient.get(`/auth/users/${userId}/sessions`),

  revokeSession: (sessionId: string): Promise<any> =>
    apiClient.delete(`/auth/sessions/${sessionId}`),

  updateUserPreferences: (userId: string, preferences: any): Promise<any> =>
    apiClient.post(`/auth/users/${userId}/preferences`, preferences),

  updateUserStatus: (userId: string, status: string): Promise<any> =>
    apiClient.post(`/auth/users/${userId}/status`, { status }),

  forgotPassword: (email: string): Promise<{ message: string; email_sent?: boolean }> =>
    apiClient.post('/password-reset/request', { email }),

  validateResetToken: (token: string): Promise<{ valid: boolean; user_name?: string; email?: string; expires_at?: string }> =>
    apiClient.post('/password-reset/validate', { token }),

  resetPassword: (token: string, newPassword: string, confirmPassword: string): Promise<{ message: string; success: boolean }> =>
    apiClient.post('/password-reset/confirm', { token, new_password: newPassword, confirm_password: confirmPassword }),
}
